<template>
  <ymap-marker
    marker-type="Polygon"
    :marker-id="polygon.id"
    :marker-stroke="strokeOptions"
    :marker-fill="fillOptions"
    :coords="area"
    :balloon-template="ballonTemplete"
    @click="(e) => $emit('click', e)"
  />
</template>
<script>
  import { ymapMarker } from 'vue-yandex-maps'
  import { ZONE_COLORS } from '@/constants/deliveryZones'

  export default {
    name: 'MapPolygon',
    components: { ymapMarker },
    props: {
      polygon: {
        type: Object,
        default: () => ({}),
      },
      showBalloon: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ballonTemplete () {
        return this.showBalloon
          ? '<p>' + this.polygon.name + ' (' + this.polygon.id + ')</p>'
          : null
      },
      polygonColor () {
        return (
          ZONE_COLORS[this.polygon.type] ||
          '#' + Math.random().toString(16).slice(3, 9)
        )
      },
      strokeOptions () {
        return {
          color: this.polygonColor,
          opacity: 0.2,
          width: 1,
        }
      },
      fillOptions () {
        return {
          enabled: true,
          color: this.polygonColor,
          opacity: 0.4,
        }
      },
      area () {
        return [
          this.polygon.area.coordinates[0].map((v) => {
            return [v[1], v[0]]
          }),
        ]
      },
    },
  }
</script>

<style scoped lang="less"></style>
